import { Layout, Help as HelpComponent } from "components"
export const Help = () => {
 return (
  <Layout>
   <HelpComponent />
  </Layout>
 )
}
